var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPyramid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1253,
    height: 678,
    viewBox: "98 0 1253 678",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M723.5 0L1350.07 678.75H96.9306L723.5 0Z",
    fill: "#F3B29D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M545.331 193H901.659L1059.5 364H387.5L545.331 193Z",
    fill: "#7A709B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 364H1059.5L1217.37 535H229.5L387.5 364Z",
    fill: "#3E355C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyramid);
export default __webpack_public_path__ + "static/media/pyramid.fc652c2d9f46b96117cc78832a6408c3.svg";
export { ForwardRef as ReactComponent };